import { format } from "date-fns"

export function InvoiceDate({ date }: { date: string | Date }) {
  return format(new Date(date), "MMM do, yyyy")
}
